import { render, staticRenderFns } from "./MapBlock.vue?vue&type=template&id=5e967bca&"
import script from "./MapBlock.vue?vue&type=script&lang=js&"
export * from "./MapBlock.vue?vue&type=script&lang=js&"
import style0 from "./MapBlock.vue?vue&type=style&index=0&id=5e967bca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports